(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/quick-bet-button.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/quick-bet-button.js');
"use strict";

const _excluded = ["children", "path", "ariaLabel", "trackingLabel", "outcomeId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

const {
  getNavigateLinkToSportbook,
  trackSportbookEvent
} = svs.components.oddset.quickBets.common.utils;
const Button = svs.ui.ReactButton;
const QuickBetButton = _ref => {
  let {
      children,
      path,
      ariaLabel,
      trackingLabel,
      outcomeId
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(Button, _extends({
    "aria-label": ariaLabel,
    block: true,
    href: getNavigateLinkToSportbook({
      path,
      outcomeId
    }),
    onClick: () => trackSportbookEvent(trackingLabel),
    target: "_blank",
    thin: true,
    transparent: true
  }, rest), children);
};
setGlobal('svs.components.oddset.quickBets.QuickBetButton', QuickBetButton);

 })(window);